import { render, staticRenderFns } from "./upkeep-alert.vue?vue&type=template&id=489b3418"
import script from "./upkeep-alert.vue?vue&type=script&lang=ts"
export * from "./upkeep-alert.vue?vue&type=script&lang=ts"
import style0 from "./upkeep-alert.vue?vue&type=style&index=0&id=489b3418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports